import { useEffect, useState, useCallback } from "react";
import { adminClient } from "@/lib/apiClient";

// Generic data fetcher for admin lists. Returns { items, loading, error, reload }.
export function useAdminData(endpoint, deps = []) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const reload = useCallback(async () => {
    setLoading(true); setError("");
    try {
      const res = await adminClient.get(endpoint);
      setItems(res.data || []);
    } catch (e) {
      setError(e?.response?.data?.detail || "Could not load data");
      // bubble up auth errors so the caller can redirect
      if (e?.response?.status === 401) setError("unauthorized");
    } finally { setLoading(false); }
  }, [endpoint]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { reload(); }, [reload, ...deps]);

  return { items, loading, error, reload, setItems };
}
